import React from 'react';
import { Box } from '@mui/material';

export function Flag({ language }: { language: string }) {
  return (
    <Box
      component="img"
      sx={{
        borderRadius: 26,
        height: 26,
        width: 26,
      }}
      src={`${BASE_PATH}/assets/template/assets/flags/${language}.svg`}
      alt={language}
    />
  );
}
